export const selectCurrentAnnouncement = state =>
  state.modal.currentAnnouncement;

export const selectNewAnnouncement = state => state.modal.newAnnouncement;
